import { FC } from "react"

interface PaginaLogoIntelbrasProps {
    logo: string;
    children?: React.ReactNode;
    pagina?: number;
    addBottom?: boolean;
}

const PaginaLogoIntelbras: FC<PaginaLogoIntelbrasProps> = ({ logo, children, pagina, addBottom }) => {
    return (
        <>
            <div className="page-break" />

            <div className="page page-logo">
                <div className="page-header">
                    {logo ? (
                        <img src={logo} className="image-logo-intelbras" alt="Logo Intelbras" />
                    ) : null}
                </div>
                {children}

                {/* <div className="print-footer" style={addBottom ? { bottom: "20pt" } : {}}>
                    Proposta Detalhada | <span className="page-number">{pagina || ""}</span>
                </div> */}
            </div >
        </>
    );
};

export default PaginaLogoIntelbras;